/*
 * faq-anchors.js — deep links to a single FAQ question, both directions.
 *
 * Every collapsible row renders an id on its .accordion wrapper (see
 * sections/collapsible-content.liquid), so a question has a stable URL:
 *
 *   https://epochoutdoors.com/pages/faq-contact-us#faq-shipping-time
 *
 * IN:  a <details> element does not open itself for a URL hash, and the
 *      browser's native jump lands on a collapsed row — the customer sees the
 *      question but not the answer. We open the row and scroll it under the
 *      sticky header.
 * OUT: opening a row writes its anchor into the address bar, so getting the
 *      link for a question is "click it, copy the URL" instead of knowing the
 *      anchor. replaceState, not pushState — the back button should leave the
 *      page, not walk back through every question the customer opened.
 */
(function () {
  if (window.__epochFaqAnchors) return; // the section can load this once per FAQ group
  window.__epochFaqAnchors = true;

  var ROW = '.accordion[id] > details';

  // The FAQ page is long and image-heavy, so we re-assert the scroll once
  // everything has loaded — but never against a customer who has taken over.
  var userTookOver = false;
  ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, function () { userTookOver = true; }, { passive: true, once: true });
  });

  function currentId() {
    var raw = window.location.hash.slice(1);
    try {
      return decodeURIComponent(raw);
    } catch (e) {
      return raw;
    }
  }

  // Keep the query string: in a theme preview the URL carries preview_theme_id,
  // and dropping it would bounce the customer onto the published theme.
  function setHash(id) {
    if (!window.history || !window.history.replaceState) return;
    var url = window.location.pathname + window.location.search + (id ? '#' + id : '');
    window.history.replaceState(null, '', url);
  }

  function reveal(id) {
    if (!id) return false;

    var target = document.getElementById(id);
    if (!target) return false;

    var details = target.querySelector('details') || target.closest('details');
    if (details && !details.open) details.open = true;

    // Let the row finish expanding before measuring where to scroll.
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return true;
  }

  // A row that opens becomes the address; a row that closes gives it back.
  function bind(root) {
    (root || document).querySelectorAll(ROW).forEach(function (details) {
      if (details.__epochAnchorBound) return;
      details.__epochAnchorBound = true;

      details.addEventListener('toggle', function () {
        var id = details.parentElement.id;
        if (details.open) {
          if (currentId() !== id) setHash(id);
        } else if (currentId() === id) {
          setHash(null);
        }
      });
    });
  }

  function onReady() {
    bind();
    reveal(currentId());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  // Images above the target settle late and push it off-screen; land it again.
  window.addEventListener('load', function () {
    if (!userTookOver) reveal(currentId());
  });

  // Same-page links (in-answer cross references, a pasted link in an open tab).
  // replaceState does not fire this, so tracking a click cannot loop back here.
  window.addEventListener('hashchange', function () {
    reveal(currentId());
  });

  // The theme editor re-renders a section in place; its rows need binding too.
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
